import { SnackbarProvider } from '@/components/snackbarProvider';
import { ThemeProvider } from '@/theme';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import App from './App';
import { store } from './store';
const rootElement = document.querySelector('#root');
if (!rootElement)
    throw new Error('Failed to find the root element');
const root = createRoot(rootElement);
const Main = () => {
    return (React.createElement(StrictMode, null,
        React.createElement(ReduxProvider, { store: store },
            React.createElement(ThemeProvider, null,
                React.createElement(SnackbarProvider, null),
                React.createElement(App, null)))));
};
root.render(React.createElement(Main, null));
